import navPanel from '../../components/nav-panel/nav-panel';
import navMobile from '../../components/nav-mobile/nav-mobile';
import pageSubnavigation from '../../components/aside-navigation/aside-navigation';
import topBar from '../../components/top-bar/top-bar';
import topBarSearch from '../../components/top-bar-search/top-bar-search';
import articleHighlight from '../../blocks/article-highlight/article-highlight';
import moduleHelperToggleBox from '../../components/module-helper-toggle-box/module-helper-toggle-box';
import newsArchive from '../../blocks/news-archive/news-archive';
import documentListing from '../../blocks/document-listing/document-listing';
import serviceSearch from '../../blocks/service-search/service-search';
import projectSearch from '../../blocks/project-search/project-search';
import contactSearch from '../../blocks/contact-search/contact-search';
import searchEngine from '../../components/search-engine/search-engine';
import contactPopup from '../../components/contact-popup/contact-popup';

const appStart = () => {
  navPanel();
  navMobile();
  topBar();
  topBarSearch();
  pageSubnavigation();
  articleHighlight();
  newsArchive();
  documentListing();
  serviceSearch();
  projectSearch();
  contactSearch();
  searchEngine();
  contactPopup();

  moduleHelperToggleBox();
};

// 'DOMContentLoaded' may fire before your script has a chance to run.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', appStart);
} else {
  appStart();
}
